import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from "@angular/core";

import { Permitions } from "../models/permitions";
import { SessionService } from "../services/session.service";
import { TxtConv } from "../helpers/txt-conv";
import * as moment from "moment";
import { DateConv } from "../helpers/date-conv";

export interface ObjPermition {
  obj: string;
  scope?: string;
  value?: any;
}

@Directive({
  selector: "[appPermissionModule]",
})
export class PermissionModuleDirective implements OnInit {
  // region Atributos
  isVisible = false;
  permissionsModule: Permitions[];
  @Input() appPermissionModule: ObjPermition;

  // endregion

  // region Constructor
  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private userService: SessionService
  ) {
    //this.permissionsModule = this.userService.getPermitionsModules();
  }

  // endregion

  //region Métodos
  ngOnInit(): void {
    // Verificamos si tiene el permiso para ver el recurso
    this.isAllowedModule();
  }

  public isAllowedModule() {
    this.visibleTemplate();

   /*  if (this.appPermissionModule && this.appPermissionModule.obj) {
      switch (TxtConv.txtCon(this.appPermissionModule.obj, "uppercase")) {
        case "MONTHYLPAYMENTS":
          switch (TxtConv.txtCon(this.appPermissionModule.scope, "uppercase")) {
            case "APPLY":
              const allowedCorps = ["ED", "ET", "AZ"];
              let iddev = this.userService.getProfile().iddev;
              let idcorp = iddev.substr(0, 2);
              if (allowedCorps.includes(idcorp) === true) {
                this.visibleTemplate();
                return;
              } else {
                this.hideTemplate();
              }
              break;
            default:
              this.hideTemplate();
          }
          case 'REPORTS':
            if (!this.userService.getProfile()) {
              this.hideTemplate();
            }
            let intern = Number(this.userService.getProfile().intern);
            if (intern == 1) {
              this.visibleTemplate();
              return;
            } else {
              this.hideTemplate();
            }
            break;
        default:
          this.hideTemplate();
    }

    } */
    // if (this.appPermissionModule) {
    //   this.appPermissionModule = TxtConv.txtCon(this.appPermissionModule, 'uppercase');
    //   // console.log(this.appPermissionModule);
    //   // console.log(this.actionsModule);
    //   for (let i = 0; i < this.permissionsModule.length; i ++) {
    //     if (this.permissionsModule[i].module === this.appPermissionModule) {
    //       this.visibleTemplate();
    //       break;
    //     } else {
    //       this.hideTemplate();
    //     }
    //   }
    // }
  }

  // Función privada para manejar si ya se aplico la directiva para crear el elemento embebido
  private visibleTemplate() {
    if (!this.isVisible) {
      this.isVisible = true;
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }

  // Función para ocultar el elemento a la que se aplica la directiva
  private hideTemplate() {
    this.isVisible = false;
    this.viewContainerRef.clear();
  }

  //endregion
}
